import { createSelector } from 'reselect'

import { ReduxStoreState } from 'Models'
import { isLoadingSelector } from 'ReduxStore/common/isLoadingSelector'
import { isKeycloakProfileLoadingSelector } from 'ReduxStore/coreBackendUser'
import { journalEatableRecordsSelector } from 'ReduxStore/journalEatableRecords'
import { journalEnergyMotionRecordsSelector } from 'ReduxStore/journalEnergyMotionRecords'
import { journalEnergyRecordsSelector } from 'ReduxStore/journalEnergyRecords'
import { journalMotionRecordsSelector } from 'ReduxStore/journalMotionRecords'
import { hasProspectiveCustomerRoleSelector } from 'ReduxStore/keyCloakUser'
import { isResetUserLoadingSelector } from 'ReduxStore/resetUser'

export const dayJournalCardsCombinedLoadingSelector = createSelector(
  [
    journalEatableRecordsSelector,
    journalEnergyRecordsSelector,
    journalMotionRecordsSelector,
    journalEnergyMotionRecordsSelector
  ],
  (journalEatableRecords, journalEnergyRecords, journalMotionRecords, journalEnergyMotionRecords) =>
    journalEatableRecords.pendingCounter +
      journalEnergyRecords.pendingCounter +
      journalMotionRecords.pendingCounter +
      journalEnergyMotionRecords.pendingCounter >
    0
)

export const journalDayCardsListLoadingSelector = createSelector(
  [
    dayJournalCardsCombinedLoadingSelector,
    (state: ReduxStoreState) => isLoadingSelector(state.menuPlan),
    (state: ReduxStoreState) => isLoadingSelector(state.fitnessPlan)
  ],
  (journalListsLoading, menuPlanLoading, fitnessPlanLoading) =>
    journalListsLoading || menuPlanLoading || fitnessPlanLoading
)

export const isUserLoadingSelector = createSelector(
  [isKeycloakProfileLoadingSelector, isResetUserLoadingSelector],
  (isKeycloakProfileLoading, isResetUserLoading) => isKeycloakProfileLoading || isResetUserLoading
)

export const isProspectiveCustomerSelector = hasProspectiveCustomerRoleSelector
